/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateCustomerProfileDto } from '../models/CreateCustomerProfileDto';
import type { CustomerProfile } from '../models/CustomerProfile';
import type { CustomerProfilesPaginatedResponseDto } from '../models/CustomerProfilesPaginatedResponseDto';
import type { UpdateCustomerProfileDto } from '../models/UpdateCustomerProfileDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CustomerProfilesService {
    /**
     * Create a new customer profile
     * @param requestBody
     * @returns CustomerProfile Customer profile created successfully
     * @throws ApiError
     */
    public static customerProfilesControllerCreate(
        requestBody: CreateCustomerProfileDto,
    ): CancelablePromise<CustomerProfile> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/customer-profiles',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid customer data`,
            },
        });
    }
    /**
     * List customer profiles (paginated, with optional filters)
     * @param page
     * @param limit
     * @param searchTerm Matches name, email, phone, or CI (partial)
     * @param email
     * @param phone
     * @param loyaltyTier
     * @param saleDateFrom Solo clientes con ventas pagadas desde esta fecha (YYYY-MM-DD o ISO); acota total/n compras al rango
     * @param saleDateTo Solo clientes con ventas pagadas hasta esta fecha (YYYY-MM-DD o ISO); acota total/n compras al rango
     * @returns CustomerProfilesPaginatedResponseDto Paginated customer profiles
     * @throws ApiError
     */
    public static customerProfilesControllerFindAll(
        page?: number,
        limit?: number,
        searchTerm?: string,
        email?: string,
        phone?: string,
        loyaltyTier?: 'BRONZE' | 'SILVER' | 'GOLD' | 'PLATINUM',
        saleDateFrom?: string,
        saleDateTo?: string,
    ): CancelablePromise<CustomerProfilesPaginatedResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/customer-profiles',
            query: {
                'page': page,
                'limit': limit,
                'searchTerm': searchTerm,
                'email': email,
                'phone': phone,
                'loyaltyTier': loyaltyTier,
                'saleDateFrom': saleDateFrom,
                'saleDateTo': saleDateTo,
            },
        });
    }
    /**
     * Search customers by name, email, or phone
     * @param term Search term (name, email, or phone)
     * @returns CustomerProfile Search results
     * @throws ApiError
     */
    public static customerProfilesControllerSearch(
        term: string,
    ): CancelablePromise<Array<CustomerProfile>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/customer-profiles/search',
            query: {
                'term': term,
            },
        });
    }
    /**
     * Get top customers by total purchases
     * @param limit Maximum number of customers to return
     * @returns CustomerProfile Top customers list
     * @throws ApiError
     */
    public static customerProfilesControllerGetTopCustomers(
        limit?: number,
    ): CancelablePromise<Array<CustomerProfile>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/customer-profiles/top-customers',
            query: {
                'limit': limit,
            },
        });
    }
    /**
     * Get customers by loyalty tier
     * @param tier
     * @returns CustomerProfile Customers by tier
     * @throws ApiError
     */
    public static customerProfilesControllerGetCustomersByTier(
        tier: string,
    ): CancelablePromise<Array<CustomerProfile>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/customer-profiles/by-tier/{tier}',
            path: {
                'tier': tier,
            },
        });
    }
    /**
     * Find customer by email
     * @param email
     * @returns CustomerProfile Customer found
     * @throws ApiError
     */
    public static customerProfilesControllerFindByEmail(
        email: string,
    ): CancelablePromise<CustomerProfile> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/customer-profiles/by-email/{email}',
            path: {
                'email': email,
            },
            errors: {
                404: `Customer not found`,
            },
        });
    }
    /**
     * Find customer by phone
     * @param phone
     * @returns CustomerProfile Customer found
     * @throws ApiError
     */
    public static customerProfilesControllerFindByPhone(
        phone: string,
    ): CancelablePromise<CustomerProfile> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/customer-profiles/by-phone/{phone}',
            path: {
                'phone': phone,
            },
            errors: {
                404: `Customer not found`,
            },
        });
    }
    /**
     * Get customer profile by ID
     * @param id
     * @returns CustomerProfile Customer profile details
     * @throws ApiError
     */
    public static customerProfilesControllerFindOne(
        id: number,
    ): CancelablePromise<CustomerProfile> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/customer-profiles/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Customer not found`,
            },
        });
    }
    /**
     * Update customer profile
     * @param id
     * @param requestBody
     * @returns CustomerProfile Customer profile updated successfully
     * @throws ApiError
     */
    public static customerProfilesControllerUpdate(
        id: number,
        requestBody: UpdateCustomerProfileDto,
    ): CancelablePromise<CustomerProfile> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/customer-profiles/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request - Email already exists`,
                404: `Customer not found`,
            },
        });
    }
    /**
     * Delete customer profile
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static customerProfilesControllerRemove(
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/customer-profiles/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Cannot delete customer with active orders`,
                404: `Customer not found`,
            },
        });
    }
    /**
     * Get customer sales history (partially paid, paid, delivered, refunded; post-sale markers)
     * @param id
     * @param page
     * @param limit
     * @returns any Customer sales history with refund/exchange flags
     * @throws ApiError
     */
    public static customerProfilesControllerGetSalesHistory(
        id: number,
        page?: number,
        limit?: number,
    ): CancelablePromise<{
        data?: Array<{
            orderId?: number;
            orderCode?: string;
            saleDate?: string;
            createdAt?: string;
            totalAmount?: number;
            orderStatus?: string;
            locationName?: string | null;
            hasRefund?: boolean;
            hasExchange?: boolean;
            postSaleStatus?: 'NONE' | 'REFUNDED' | 'EXCHANGED' | 'REFUNDED_AND_EXCHANGED';
        }>;
        total?: number;
        page?: number;
        limit?: number;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/customer-profiles/{id}/sales-history',
            path: {
                'id': id,
            },
            query: {
                'page': page,
                'limit': limit,
            },
        });
    }
    /**
     * Redeem loyalty points for discount
     * @param id
     * @returns any Points redeemed successfully
     * @throws ApiError
     */
    public static customerProfilesControllerRedeemLoyaltyPoints(
        id: number,
    ): CancelablePromise<{
        customerId?: number;
        pointsRedeemed?: number;
        discountAmount?: number;
        remainingPoints?: number;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/customer-profiles/{id}/redeem-points',
            path: {
                'id': id,
            },
            errors: {
                400: `Insufficient points`,
            },
        });
    }
    /**
     * Update customer purchase statistics
     * @param id
     * @returns any Purchase statistics updated successfully
     * @throws ApiError
     */
    public static customerProfilesControllerUpdatePurchaseStats(
        id: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/customer-profiles/{id}/update-purchase-stats',
            path: {
                'id': id,
            },
            errors: {
                404: `Customer not found`,
            },
        });
    }
}
